import { GamePlayGameId, GameStatus } from 'game-services'
import { GamePlayStatus } from './game-play.status'
import { GamePlayPlayer, gamePlayPlayerNull } from './game-play-player'

interface GamePlayProps {
  readonly gameShortId: string
  readonly gamePlayId: string
  readonly currentGame: GamePlayGame
  readonly status: GamePlayStatus
  readonly shouldShowCompletedGame: boolean
  readonly user: GamePlayPlayer
  readonly rightOpponent: GamePlayPlayer
  readonly leftOpponent: GamePlayPlayer
}

export class GamePlayGame {
  public constructor(
    public readonly gamePlayId: string,
    public readonly gameId: string,
    public readonly gameStatus: GameStatus,
  ) {}

  public readonly gamePlayGameId: GamePlayGameId = {
    gamePlayId: this.gamePlayId,
    gameId: this.gameId,
  }
}

export class GamePlay {
  public constructor(private readonly props: GamePlayProps) {}

  public get gameShortId(): string {
    return this.props.gameShortId
  }

  public get gamePlayId(): string {
    return this.props.gamePlayId
  }

  public get currentGame(): GamePlayGame {
    return this.props.currentGame
  }

  public get status(): GamePlayStatus {
    return this.props.status
  }

  public get shouldShowCompletedGame(): boolean {
    return this.props.shouldShowCompletedGame
  }

  public get user(): GamePlayPlayer {
    return this.props.user
  }

  public get rightOpponent(): GamePlayPlayer {
    return this.props.rightOpponent
  }

  public get leftOpponent(): GamePlayPlayer {
    return this.props.leftOpponent
  }

  public get players(): GamePlayPlayer[] {
    return [this.user, this.rightOpponent, this.leftOpponent]
  }

  public get userIds(): string[] {
    return this.players.map((player) => player.userId)
  }
}

const gamePlayGameNull: GamePlayGame = new GamePlayGame('', '', 'DealingCards')

export const gamePlayNull: GamePlay = new GamePlay({
  gameShortId: '',
  gamePlayId: '',
  currentGame: gamePlayGameNull,
  status: 'Created',
  shouldShowCompletedGame: false,
  user: gamePlayPlayerNull,
  rightOpponent: gamePlayPlayerNull,
  leftOpponent: gamePlayPlayerNull,
})
